export const SEARCH_PATH = '/other/search';
